import React from "react";
import "./DurationPresets.css";

function DurationPresets({ startTime, onChangeEndTime, endTimeRef }) {
  const presets = [
    { label: "30m", minutes: 30 },
    { label: "45m", minutes: 45 },
    { label: "1h", minutes: 60 },
    { label: "1h 30m", minutes: 90 },
    { label: "2h", minutes: 120 },
  ];

  const applyPreset = (minutes) => {
    if (!startTime) return;

    const [h, m] = startTime.split(":").map(Number);
    const start = new Date();
    start.setHours(h, m, 0, 0);

    const end = new Date(start.getTime() + minutes * 60000);
    const hh = String(end.getHours()).padStart(2, "0");
    const mm = String(end.getMinutes()).padStart(2, "0");

    onChangeEndTime(`${hh}:${mm}`);

    if (endTimeRef?.current) {
      endTimeRef.current.focus();
    }
  };

  return (
    <div className="duration-presets">
      {presets.map((p) => (
        <button
          key={p.label}
          className="preset-btn"
          onClick={() => applyPreset(p.minutes)}
        >
          {p.label}
        </button>
      ))}
    </div>
  );
}

export default DurationPresets;
